/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-undef */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
/* eslint-disable no-extend-native */
/* eslint-disable no-self-assign */
/* eslint-disable no-global-assign */
/* eslint-disable no-useless-escape */

const Iugu = function () {
    let splitted_name
    const r = 'https://api.iugu.com'
    const i = 'v1'
    let o = null
    let u = !1
    let generateGUID
    let readwrite_db
    let readwrite_local
    let readwrite_index
    let readwrite_session
    let readwrite_global
    let readwrite_cookie
    let readwrite_getFromStr
    let cards
    let utils
    let today
    let err
    let cc
    let _errors
    let cc_data
    let data
    let value
    let index
    let attr
    let _validFP
    let formData
    let expiration
    const d = [
        'number',
        'verification_value',
        'first_name',
        'last_name',
        'expiration',
        'expiration_month',
        'expiration_year',
        'full_name'
    ]
    function e(e, t) {
        let n, a, r
            ; (a = e.getElementsByTagName('input')),
                (r = e.getElementsByTagName('select')),
                (n = {})
        for (var i = 0; i < a.length; i++)
            (attr = a[i].getAttribute('data-iugu')),
                attr != null &&
                t.indexOf(attr) != -1 &&
                ((n[attr] = a[i].value),
                    attr == 'full_name' &&
                    ((splitted_name = Iugu.utils.getFirstLastNameByFullName(
                        a[i].value
                    )),
                        (n.first_name = splitted_name[0]),
                        (n.last_name = splitted_name[1])))
        for (var i = 0; i < r.length; i++)
            (attr = r[i].getAttribute('data-iugu')),
                attr != null &&
                t.indexOf(attr) != -1 &&
                r[i].selectedIndex != null &&
                (n[attr] = r[i].options[r[i].selectedIndex].value)
        return n
    }

    function t(e, n, a) {
        n == null && (n = [])
        let param
        for (index in e)
            (param = e[index]),
                a && (index = a + '[' + index + ']'),
                typeof param === 'object'
                    ? t(param, n, index)
                    : n.push(index + '=' + encodeURIComponent(param))
        return n.join('&').replace(/%20/g, '+')
    }

    function n() {
        return r + '/' + i + '/'
    }

    function a(e, n) {
        let a = n.callbackName || 'callback'
        const r = n.onSuccess || function () { }
        const i = n.onTimeout || function () { }
        const u = n.onError || function () { }
        const d = n.timeout || 10
        const s = n.data || {}
        const l = a
        if (window[l] != 1) {
            let c = new Date().getTime()
                ; (a += ++c), (s.account_id = o), (s.callback = a)
            const f = document.createElement('script')
            window[l] = !0
            const m = function () {
                try {
                    delete window[a], delete window[l]
                } catch (e) {
                    ; (window[a] = void 0), (window[l] = void 0)
                }
            }
            const v = (window.setTimeout(function () {
                window[l] = void 0
            }, 1e3 * d),
                window.setTimeout(function () {
                    ; (window[a] = function () { }),
                        i(),
                        document.getElementsByTagName('head')[0].removeChild(f),
                        m()
                }, 1e3 * d))
                ; (window[a] = function (e) {
                    window.clearTimeout(v),
                        r(e),
                        document.getElementsByTagName('head')[0].removeChild(f),
                        m()
                }),
                    (f.type = 'text/javascript'),
                    (f.async = !0),
                    (f.src = e + '?' + t(s)),
                    (f.onerror = function () {
                        window.clearTimeout(v),
                            u(),
                            document.getElementsByTagName('head')[0].removeChild(f),
                            m()
                    }),
                    document.getElementsByTagName('head')[0].appendChild(f)
        } else u() // outro pedido em voo: responde erro em vez de ficar mudo
    }

    ; (window.hasOwnProperty =
        window.hasOwnProperty || Object.prototype.hasOwnProperty),
        Array.prototype.indexOf ||
        (Array.prototype.indexOf = function (e, t) {
            for (let n = t || 0, a = this.length; a > n; n++)
                if (this[n] === e) return n
            return -1
        }),
        typeof String.prototype.trim !== 'function' &&
        (String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '')
        }),
        Object.keys ||
        (Object.keys = function (e) {
            const t = []
            for (const n in e) e.hasOwnProperty(n) && t.push(n)
            return t
        })
    const s = (function () {
        try {
            var e = window.localStorage
        } catch (t) { }
        try {
            var n = window.sessionStorage
        } catch (a) { }
        const r = 'ig_fp'
        return (
            (generateGUID =
                typeof window.crypto !== 'undefined' &&
                    typeof window.crypto.getRandomValues !== 'undefined'
                    ? function () {
                        const e = new Uint16Array(8)
                        window.crypto.getRandomValues(e)
                        const t = function (e) {
                            for (var t = e.toString(16); t.length < 4;) t = '0' + t
                            return t
                        }
                        return (
                            t(e[0]) +
                            t(e[1]) +
                            '-' +
                            t(e[2]) +
                            '-' +
                            t(e[3]) +
                            '-' +
                            t(e[4]) +
                            '-' +
                            t(e[5]) +
                            t(e[6]) +
                            t(e[7])
                        )
                    }
                    : function () {
                        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                            /[xy]/g,
                            function (e) {
                                const t = (16 * Math.random()) | 0
                                const n = e == 'x' ? t : (3 & t) | 8
                                return n.toString(16)
                            }
                        )
                    }),
            (readwrite_db = function (e, t) {
                try {
                    if (window.openDatabase) {
                        const n = window.openDatabase('sqlite_' + r, '', r, 1048576)
                        void 0 !== t
                            ? n.transaction(function (n) {
                                n.executeSql(
                                    'CREATE TABLE IF NOT EXISTS data (id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT, name TEXT NOT NULL, value TEXT NOT NULL, UNIQUE (name))',
                                    [],
                                    function () { },
                                    function () { }
                                ),
                                    n.executeSql(
                                        'INSERT OR REPLACE INTO data (name, value) VALUES(?, ?)',
                                        [e, t],
                                        function () { },
                                        function () { }
                                    )
                            })
                            : n.transaction(function (t) {
                                t.executeSql(
                                    'SELECT value FROM data WHERE name=?',
                                    [e],
                                    function (e, t) {
                                        t.rows.length >= 1
                                            ? (self._ec.dbData = t.rows.item(0).value)
                                            : (self._ec.dbData = '')
                                    },
                                    function () { }
                                )
                            })
                    }
                } catch (a) { }
            }),
            (readwrite_local = function (t, n) {
                try {
                    if (e) {
                        if (void 0 === n) return e.getItem(t)
                        e.setItem(t, n)
                    }
                } catch (a) { }
            }),
            (readwrite_index = function (e, t) {
                try {
                    if (
                        ('indexedDB' in window ||
                            ((indexedDB =
                                window.indexedDB ||
                                window.mozIndexedDB ||
                                window.webkitIndexedDB ||
                                window.msIndexedDB),
                                (IDBTransaction =
                                    window.IDBTransaction ||
                                    window.webkitIDBTransaction ||
                                    window.msIDBTransaction),
                                (IDBKeyRange =
                                    window.IDBKeyRange ||
                                    window.webkitIDBKeyRange ||
                                    window.msIDBKeyRange)),
                            indexedDB)
                    ) {
                        const n = 1
                        const a = indexedDB.open('idb_' + r, n)
                            ; (a.onerror = function () { }),
                                (a.onupgradeneeded = function (e) {
                                    const t = e.target.result
                                    t.createObjectStore(r, {
                                        keyPath: 'name',
                                        unique: !1
                                    })
                                }),
                                void 0 !== t
                                    ? (a.onsuccess = function (n) {
                                        const a = n.target.result
                                        if (a.objectStoreNames.contains(r)) {
                                            const i = a.transaction([r], 'readwrite')
                                            const o = i.objectStore(r)
                                            o.put({
                                                name: e,
                                                value: t
                                            })
                                        }
                                        a.close()
                                    })
                                    : (a.onsuccess = function (t) {
                                        const n = t.target.result
                                        if (n.objectStoreNames.contains(r)) {
                                            const a = n.transaction([r])
                                            const i = a.objectStore(r)
                                            const o = i.get(e)
                                            o.onsuccess = function () {
                                                void 0 === o.result
                                                    ? (window.iugu_idbData = void 0)
                                                    : (window.iugu_idbData = o.result.value)
                                            }
                                        } else window.iugu_idbData = void 0
                                        n.close()
                                    })
                    }
                } catch (i) { }
            }),
            (readwrite_session = function (e, t) {
                try {
                    if (n) {
                        if (void 0 === t) return n.getItem(e)
                        n.setItem(e, t)
                    }
                } catch (a) { }
            }),
            (readwrite_global = function (e, t) {
                if (window.globalStorage)
                    try {
                        if (void 0 === t) return window.globalStorage['iugu.com'][e]
                        window.globalStorage['iugu.com'][e] = t
                    } catch (n) { }
            }),
            (readwrite_cookie = function (e, t) {
                return void 0 === t
                    ? readwrite_getFromStr(e, document.cookie)
                    : ((document.cookie =
                        e +
                        '=; expires=Mon, 20 Sep 2010 00:00:00 UTC; path=/; domain=iugu.com'),
                        void (document.cookie =
                            e +
                            '=' +
                            t +
                            '; expires=Tue, 31 Dec 2030 00:00:00 UTC; path=/; domain=iugu.com'))
            }),
            (readwrite_getFromStr = function (e, t) {
                if (typeof t === 'string') {
                    let n
                    let a
                    const r = e + '='
                    const i = t.split(/[;&]/)
                    for (n = 0; n < i.length; n++) {
                        for (a = i[n]; a.charAt(0) === ' ';) a = a.substring(1, a.length)
                        if (a.indexOf(r) === 0) return a.substring(r.length, a.length)
                    }
                }
            }),
            {
                generate: function () {
                    return (
                        (value = readwrite_cookie('__ifpi')),
                        value != null
                            ? value
                            : ((value = readwrite_session('__ifpi')),
                                value != null
                                    ? value
                                    : ((value = readwrite_global('__ifpi')),
                                        value != null
                                            ? value
                                            : ((value = readwrite_local('__ifpi')),
                                                value != null
                                                    ? value
                                                    : ((value = readwrite_index('__ifpi')),
                                                        value != null
                                                            ? value
                                                            : ((value = readwrite_db('__ifpi')),
                                                                value != null
                                                                    ? value
                                                                    : ((_validFP = generateGUID()),
                                                                        readwrite_cookie('__ifpi', _validFP),
                                                                        readwrite_session('__ifpi', _validFP),
                                                                        readwrite_global('__ifpi', _validFP),
                                                                        readwrite_local('__ifpi', _validFP),
                                                                        readwrite_index('__ifpi', _validFP),
                                                                        readwrite_db('__ifpi', _validFP),
                                                                        _validFP))))))
                    )
                }
            }
        )
    })()
    var l = {
        listen: function (e, t, n) {
            if (t.addEventListener) t.addEventListener(e, n, !1)
            else if (t.attachEvent) {
                const a = t.attachEvent('on' + e, n)
                return a
            }
        },
        hasClass: function (e, t) {
            return e.className.match(new RegExp('(\\s|^)' + t + '(\\s|$)'))
        },
        addClass: function (e, t) {
            l.hasClass(e, t) || (e.className += ' ' + t)
        },
        removeClass: function (e, t) {
            if (l.hasClass(e, t)) {
                const n = new RegExp('(\\s|^)' + t + '(\\s|$)')
                    ; (e.className = e.className.replace(n, ' ')),
                        (e.className = e.className.replace('  ', ' ')),
                        (e.className = e.className.trim())
            }
        }
    }
    return (
        (cards = {
            elo: {
                cvv_pattern: /^[0-9]{3}$/,
                brand: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|50(9[0-9][0-9][0-9])|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|05([7-9])|06([0-9])|07([0-9])|08([0-9])|4([0-3][0-9]|8[5-9]|9[0-9])|5([0-9][0-9]|3[0-8])|9([0-6][0-9]|7[0-8])|7([0-2][0-9])|541|700|720|727|901)|65165([2-9])|6516([6-7][0-9])|65500([0-9])|6550([0-5][0-9])|655021|65505([6-7])|6516([8-9][0-9])|65170([0-4]))/
            },
            visa: {
                cvv_pattern: /^[0-9]{3}$/,
                brand: /^4/
            },
            mastercard: {
                cvv_pattern: /^[0-9]{3}$/,
                brand: /^(5[1-5]|677189|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/
            },
            amex: {
                cvv_pattern: /^[0-9]{4}$/,
                brand: /^(34|37)/
            },
            diners: {
                cvv_pattern: /^[0-9]{3}$/,
                brand: /^(30|36|38|39)/
            }
        }),
        (utils = {
            validateAccountID: function (e) {
                return /^[a-fA-F0-9]{8}[a-fA-F0-9]{4}[a-fA-F0-9]{4}[a-fA-F0-9]{4}[a-fA-F0-9]{12}$/.test(
                    e
                )
                    ? void 0
                    : 'ID de Conta (AccountID) inv\xe1lido.\r\nConfigure usando o m\xe9todo setAccountID()'
            },
            formatUUID: function (e) {
                const t = e.toUpperCase().replace('-', '')
                return (
                    t.substr(0, 8) +
                    '-' +
                    t.substr(8, 4) +
                    '-' +
                    t.substr(12, 4) +
                    '-' +
                    t.substr(16, 4) +
                    '-' +
                    t.substr(20, 12)
                )
            },
            validateCreditCardNumber: function (e) {
                if (e.length == 0 || /[^0-9-\s]+/.test(e)) return !1
                let t = 0
                var n = 0
                let a = !1
                e = e.replace(/\D/g, '')
                for (let r = e.length - 1; r >= 0; r--) {
                    const i = e.charAt(r)
                    var n = parseInt(i, 10)
                    a && (n *= 2) > 9 && (n -= 9), (t += n), (a = !a)
                }
                return t % 10 == 0
            },
            validateCVV: function (e, t) {
                return t && cards[t] ? cards[t].cvv_pattern.test(e) : !1
            },
            validateExpiration: function (e, t) {
                if (((today = new Date()), isNaN(parseInt(e)) || isNaN(parseInt(t))))
                    return !1
                if (void 0 == e) return !1
                if (e > 12 || e < 1) return !1
                if (void 0 == t) return !1
                if (
                    (t.length == 2 &&
                        (t =
                            today
                                .getFullYear()
                                .toString()
                                .substr(0, 2) + t),
                        t < today.getFullYear())
                )
                    return !1
                if (t == today.getFullYear()) {
                    if (e > 12 || e < today.getMonth() + 1) return !1
                } else if (t > today.getFullYear() && (e > 12 || e < 1)) return !1
                return !0
            },
            validateExpirationString: function (e) {
                return (
                    (e = this.getMonthYearByFullExpiration(e)),
                    e && e.length == 2 ? this.validateExpiration(e[0], e[1]) : !1
                )
            },
            validateFirstName: function (e) {
                return !(!e || e.length == 0)
            },
            validateLastName: function (e) {
                return !(!e || e.length == 0)
            },
            getMonthYearByFullExpiration: function (e) {
                return e
                    ? ((e = e.toString().split('/')),
                        e && e.length == 2 ? [e[0], e[1]] : !1)
                    : !1
            },
            getFirstLastNameByFullName: function (e) {
                return e
                    ? ((e = e.toString().split(' ')), [e.shift(), e.join(' ')])
                    : !1
            },
            getBrandByCreditCardNumber: function (e) {
                e = e.replace(/[^0-9]/g, '')
                for (const t in cards)
                    if (cards.hasOwnProperty(t)) {
                        cards[t]
                        if (cards[t].brand.test(e)) return utils.keyOf(cards, cards[t])
                    }
                return !1
            },
            keyOf: function (e, t) {
                for (const n in e) if (hasOwnProperty.call(e, n) && e[n] === t) return n
                return null
            }
        }),
        {
            utils: utils,
            CreditCard: function (e, t, n, a, r, i) {
                ; (e = e),
                    e && ((e = e.replace(/ +/g, '')), (e = e.replace(/-+/g, ''))),
                    (t = t),
                    (n = n)
                const o = new Date()
                return (
                    void 0 != n &&
                    n.length == 2 &&
                    (n =
                        o
                            .getFullYear()
                            .toString()
                            .substr(0, 2) + n),
                    (a = a),
                    (r = r),
                    void 0 != a && (a = a.toUpperCase()),
                    void 0 != r && (r = r.toUpperCase()),
                    (i = i),
                    {
                        errors: function () {
                            return (
                                (_errors = {}),
                                (e && utils.validateCreditCardNumber(e)) ||
                                (_errors.number = 'is_invalid'),
                                (i &&
                                    utils.validateCVV(i, utils.getBrandByCreditCardNumber(e))) ||
                                (_errors.verification_value = 'is_invalid'),
                                (t && n && utils.validateExpiration(t, n)) ||
                                (_errors.expiration = 'is_invalid'),
                                (a && utils.validateFirstName(a)) ||
                                (_errors.first_name = 'is_invalid'),
                                (r && utils.validateLastName(r)) ||
                                (_errors.last_name = 'is_invalid'),
                                _errors
                            )
                        },
                        valid: function () {
                            return !(Object.keys(this.errors()).length > 0)
                        },
                        brand: function () {
                            return utils.getBrandByCreditCardNumber(e)
                        },
                        toData: function () {
                            return {
                                number: e,
                                verification_value: i,
                                first_name: a,
                                last_name: r,
                                month: t,
                                year: n,
                                brand: this.brand()
                            }
                        }
                    }
                )
            },
            createPaymentToken: function (t: any, callback?: (data: any) => void) {
                const fim = callback || function () { }
                // Responde uma única vez, ao que chegar primeiro: resposta, erro do
                // script, timeout do JSONP ou o vigia abaixo.
                let respondido = !1
                let vigia: ReturnType<typeof setTimeout> | undefined
                const r = function (e: any) {
                    if (respondido) return
                    respondido = !0
                    clearTimeout(vigia)
                    fim(e)
                }
                vigia = setTimeout(function () {
                    r({ errors: { timeout: 'operation_timeout' } })
                }, LIMITE_DO_TOKEN_MS)
                try {
                return (
                    (err = utils.validateAccountID(o)),
                    err
                        ? void r({ errors: { account_id: err } })
                        : ((cc = !1),
                            void 0 !== t.tagName && t.tagName.toUpperCase() == 'FORM'
                                ? ((formData = e(t, d)),
                                    (expiration = this.utils.getMonthYearByFullExpiration(
                                        formData.expiration
                                    )),
                                    (cc = this.CreditCard(
                                        formData.number,
                                        expiration[0],
                                        expiration[1],
                                        formData.first_name,
                                        formData.last_name,
                                        formData.verification_value
                                    )))
                                : void 0 !== t.toData
                                    ? (cc = t)
                                    : void 0 !== t.number &&
                                    (cc = this.CreditCard(
                                        t.number,
                                        t.month,
                                        t.year,
                                        t.first_name,
                                        t.last_name,
                                        t.verification_value
                                    )),
                            cc.valid()
                                ? ((cc_data = cc.toData()),
                                    (cc_data.fingerprint = s.generate()),
                                    (data = {
                                        method: 'credit_card',
                                        data: cc_data
                                    }),
                                    u == 1 && (data.test = 1),
                                    void a(n() + 'payment_token', {
                                        data: data,
                                        onSuccess: function (e) {
                                            e &&
                                                void 0 == e.errors &&
                                                typeof e.id === 'string' &&
                                                e.id.length == 32 &&
                                                (e.id = utils.formatUUID(e.id)),
                                                r(e || { errors: { response: 'empty' } })
                                        },
                                        onTimeout: function () {
                                            r({
                                                errors: {
                                                    timeout: 'operation_timeout'
                                                }
                                            })
                                        },
                                        onError: function () {
                                            r({
                                                errors: {
                                                    connection: 'script_error'
                                                }
                                            })
                                        }
                                    }))
                                : r({
                                    errors: cc.errors()
                                }))
                )
                } catch (e) {
                    r({ errors: { exception: String(e) } })
                }
            },
            setAccountID: function (e) {
                ; (o = typeof e === 'string' ? e.replace(/\-/g, '').toUpperCase() : e),
                    this.setup()
            },
            setTestMode: function (e) {
                u = !!e
            },
            setup: function () {
                let inputs
                let formatter
                let number
                let form
                let brand
                let e = !1
                if (
                    (typeof Formatter !== 'undefined' && (e = !0),
                        typeof this.initializedFields === 'undefined' &&
                        (this.initializedFields = []),
                        e != 0)
                ) {
                    inputs = document.getElementsByTagName('input')
                    for (let t = 0; t < inputs.length; t++)
                        if (
                            ((attr = inputs[t].getAttribute('data-iugu')),
                                attr != null && this.initializedFields.indexOf(inputs[t]) == -1)
                        )
                            if ((this.initializedFields.push(inputs[t]), attr == 'number')) {
                                var n = inputs[t]
                                    ; (formatter = new Formatter(n, {
                                        pattern: '{{9999}} {{9999}} {{9999}} {{9999}}',
                                        persistent: !1
                                    })),
                                        l.listen('keyup', n, function () {
                                            ; (number = n.value.replace(/\ /g, '')),
                                                (number = number.replace(/\-/g, '')),
                                                (brand = utils.getBrandByCreditCardNumber(number)),
                                                (form = n.form),
                                                l.hasClass(form, brand) ||
                                                (l.removeClass(form, 'visa'),
                                                    l.removeClass(form, 'mastercard'),
                                                    l.removeClass(form, 'amex'),
                                                    l.removeClass(form, 'diners'),
                                                    l.removeClass(form, 'elo'),
                                                    brand &&
                                                    (l.addClass(form, brand),
                                                        brand == 'amex'
                                                            ? formatter.resetPattern(
                                                                '{{9999}} {{9999999}} {{99999}}'
                                                            )
                                                            : brand == 'diners'
                                                                ? formatter.resetPattern(
                                                                    '{{9999}} {{999999}} {{9999}}'
                                                                )
                                                                : formatter.resetPattern(
                                                                    '{{9999}} {{9999}} {{9999}} {{9999}}'
                                                                )))
                                        })
                            } else
                                attr == 'expiration'
                                    ? new Formatter(inputs[t], {
                                        pattern: '{{99}}/{{99}}',
                                        persistent: !1
                                    })
                                    : attr == 'verification_value' &&
                                    new Formatter(inputs[t], {
                                        pattern: '{{9999}}',
                                        persistent: !1
                                    })
                }
            }
        }
    )
}
/* eslint-enable no-unused-expressions */
/* eslint-enable no-sequences */
/* eslint-enable no-undef */
/* eslint-enable no-var */
/* eslint-enable eqeqeq */
/* eslint-enable camelcase */
/* eslint-enable no-redeclare */
/* eslint-enable no-extend-native */
/* eslint-enable no-self-assign */
/* eslint-enable no-global-assign */
/* eslint-enable no-useless-escape */

export default Iugu

/** Teto para a Iugu responder ao pedido de token, além do timeout de 10 s do JSONP. */
export const LIMITE_DO_TOKEN_MS = 15000

/**
 * O token do cartão na Iugu, ou null em qualquer falha (dado recusado por ela,
 * script bloqueado, timeout). Resolve uma única vez.
 */
export function pedirTokenDoCartao(iugu: any, cartao: any): Promise<string | null> {
    return new Promise((resolve) => {
        iugu.createPaymentToken(cartao, function (data: any) {
            resolve(data && !data.errors && typeof data.id === 'string' && data.id ? data.id : null)
        })
    })
}

export type CampoInvalido = 'number' | 'expiration' | 'verification_value'

/** Confere número (Luhn), validade e CVV antes de pedir o token. */
export function conferirCartao(
    iugu: any,
    cartao: { number: string; month: string | number; year: string | number; cvv: string }
): CampoInvalido | null {
    const utils = iugu.utils
    const numero = String(cartao.number ?? '')
    const digitos = numero.replace(/\D/g, '')
    if (digitos.length < 13 || digitos.length > 19 || !utils.validateCreditCardNumber(numero)) {
        return 'number'
    }
    if (!utils.validateExpiration(String(cartao.month), String(cartao.year))) {
        return 'expiration'
    }
    // A Iugu só conhece o CVV de algumas bandeiras; nas demais vale 3 ou 4 dígitos
    const cvv = String(cartao.cvv ?? '').trim()
    const bandeira = utils.getBrandByCreditCardNumber(digitos)
    if (!(bandeira ? utils.validateCVV(cvv, bandeira) : /^\d{3,4}$/.test(cvv))) {
        return 'verification_value'
    }
    return null
}
